import { Tab } from '../insight/experimental.tabset';
import { TabContext, TabType } from '../insight/tabset.model';
import { User } from '../user/user.model';

export interface HiTabConfig {
    identifier: string;
    userId?: number;
}

export function createTab(
    user: User,
    definitionIdentifier?: string,
): Tab<TabContext<HiTabConfig>> {
    const originalLabel = `${user.firstName || ''} ${
        user.lastName || ''
    }`.trim();
    return {
        id: `hi-${user.id}-${Date.now()}`,
        ctx: {
            type: TabType.HUMAN,
            originalLabel,
            label: originalLabel,
            config: {
                identifier: definitionIdentifier || 'default',
                userId: user.id,
            },
        },
    };
}
